import { useState } from "react";
import { Send, Loader2, Trophy } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { FIRST_LOAD_PHASE } from "../../data/firstLoadWeek";
import { AuthorityPhase } from "./AuthorityPhase";
import { FirstLoadWin } from "./FirstLoadWin";

const ago = (iso) => { const d = (Date.now() - new Date(iso).getTime()) / 86400000; return d < 1 ? "today" : `${Math.round(d)}d ago`; };

/* Shows once the MC watch says ACTIVE (or the carrier is signed in and the plan was already sent). */
export function FirstLoadWeek({ user, watch, checked, onToggle, sentAt }) {
  const [busy, setBusy] = useState(false);
  const [localSent, setLocalSent] = useState(null);
  const active = watch?.status === "ACTIVE";
  if (!active && !sentAt) return null;
  const last = localSent || sentAt;

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/account/authority-checklist/first-load-plan");
      setLocalSent(new Date().toISOString());
      toast.success(data.sent || data.queued ? "Plan sent — check your texts and inbox" : "Plan saved to your account");
    } catch (err) { toast.error(err?.response?.data?.detail || "Couldn't send"); }
    finally { setBusy(false); }
  };

  return (
    <div className="relative" data-testid="first-load-week">
      <div className="mb-4 rounded-2xl border border-emerald-500/40 bg-emerald-500/[0.08] px-5 py-4 flex flex-wrap items-center gap-3" data-testid="first-load-week-banner">
        <Trophy className="w-5 h-5 text-emerald-300" />
        <div className="text-sm text-emerald-100 flex-1 min-w-[200px]">
          <b>{watch?.legal_name || "Your authority"} is ACTIVE.</b> Seven days, seven moves — tick them as you go.
          {last && <span className="text-emerald-200/70"> Plan texted/emailed {ago(last)}.</span>}
        </div>
        {user && (
          <button type="button" onClick={send} disabled={busy} className="inline-flex items-center gap-1.5 rounded-full border border-emerald-400/50 bg-emerald-500/15 px-3 py-1.5 text-xs font-bold text-emerald-100 hover:bg-emerald-500/25 disabled:opacity-50" data-testid="first-load-week-send">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />} {last ? "Resend the plan" : "Text me the plan"}
          </button>
        )}
      </div>
      <AuthorityPhase phase={FIRST_LOAD_PHASE} checked={checked} onToggle={onToggle} />
      <div className="mt-4"><FirstLoadWin user={user} /></div>
    </div>
  );
}
